<template>
  <section class="container-fluid white-box mb-4">
    <form>
      <div class="row">
        <div class="col-md-12">
          <h2>Our Pricing Model</h2>
          <p class="sub-text">These include credit card processing.</p>
        </div>
        <div class="col-md-12 d-flex">
          <p>
            <b>Self Service:</b>
            <br />
            4.49% + 15c per transaction
          </p>
        </div>
        <div class="col-md-12 d-flex">
          <p>
            <b>Order Ahead:</b>
            <br />
            4.49% + 30c per transaction
          </p>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
// import axios from 'axios';
// import OrderReceipt from '@/components/HomeContainer.vue'
export default {
  name: "OurPricing",
  components: {},
  props: [],
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
  computed: {},
  watch: {},
};
</script>

<style scoped>
button {
  /* margin-left: 24px;
  margin-top: 24px; */
  margin-left: 2.22vh;
  margin-top: 2.22vh;
}

.transaction-volume {
  width: 55%;
}

.fees {
  width: 40%;
  text-align: right;
}
</style>
